/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'chart-bar': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M479.651 129.218c-229.267 0-415.127 185.858-415.127 415.13 0 229.265 185.86 415.127 415.127 415.127 229.271 0 415.128-185.862 415.128-415.127H479.65v-415.13zm64.695-64.694v415.13h415.13c0-229.272-185.86-415.13-415.13-415.13z"/>'
  }
})
